import { classed } from "@tw-classed/core";
import { withClassName } from "../../helpers";
import type { BadgeProps } from "./badge.types";

const classedBadge = classed("badge font-heading text-white", {
  variants: {
    variant: {
      primary: "bg-primary-500 border-primary-500",
      neutral: "bg-tertiary-900 border-tertiary-900",
      secondary: "bg-secondary-100 border-secondary-100 text-secondary-400",
      accent: "bg-cta-500 border-cta-500",
      success: "bg-success-600 border-success-600",
      error: "bg-error-600 border-error-600",
    },
    size: {
      xs: "badge-xs",
      sm: "badge-sm",
      md: "badge-md",
      lg: "badge-lg",
    },
  },
});

export const getBadgeClass = withClassName((props: Pick<BadgeProps, "variant" | "size">) => classedBadge(props));
